/** Poids fixes : achat 30, réservation 20, offre 15/6, salle 8, demande/RDV 10, attente 12. */
export const POIDS_SIGNAUX = {
    achat_facture: 30,
    achat_simple: 30,
    reservation: 20,
    offre_acceptee: 15,
    offre_envoyee: 6,
    viewing_room: 8,
    demande: 10,
    rendez_vous: 10,
    liste_attente: 12,
};
/** Après 90 jours, un signal conserve la moitié de ses points. */
export const DEMI_VIE_JOURS = 90;
/** K = 60 : un achat récent seul donne 39, la relation suivie approche 100. */
export const K_SCORE = 60;
const MODULES_SIGNAUX = {
    achat_facture: 'facturation',
    achat_simple: 'oeuvres',
    reservation: 'contacts',
    offre_acceptee: 'offres-relances',
    offre_envoyee: 'offres-relances',
    viewing_room: 'viewing-rooms',
    demande: 'contacts',
    rendez_vous: 'agenda-presse',
    liste_attente: 'pipeline-ventes',
};
export function causeExclusionProfil(contact) {
    if (contact.anonymiseLe != null)
        return 'anonymise';
    if (contact.fusionneDans != null)
        return 'fusionne';
    if (contact.archive)
        return 'archive';
    if (contact.nePasSolliciter)
        return 'ne_pas_solliciter';
    return null;
}
export function calculerScore({ signaux, maintenant, demiVieJours, modulesEffectifs, contact, }) {
    if (contact && causeExclusionProfil(contact))
        return null;
    const limite = new Date(maintenant);
    limite.setUTCFullYear(limite.getUTCFullYear() - 3);
    const retenus = new Map();
    for (const signal of signaux) {
        if (signal.date < limite || !modulesEffectifs.includes(MODULES_SIGNAUX[signal.signal]))
            continue;
        if (signal.signal === 'achat_simple' &&
            signal.auStand &&
            !modulesEffectifs.includes('mode-foire'))
            continue;
        // Une offre ne compte qu'au plus fort ; une salle n'apporte qu'une ouverture.
        const famille = signal.signal.startsWith('offre_') ? 'offre' : signal.signal;
        const cle = `${famille}:${signal.objetType}:${signal.objetId}`;
        const precedent = retenus.get(cle);
        if (!precedent ||
            POIDS_SIGNAUX[signal.signal] > POIDS_SIGNAUX[precedent.signal] ||
            (signal.signal === precedent.signal && signal.date > precedent.date))
            retenus.set(cle, signal);
    }
    let brut = 0;
    const lignes = [...retenus.values()]
        .map((signal) => {
        const ageJours = Math.max(0, (maintenant.getTime() - signal.date.getTime()) / 86_400_000);
        const poids = POIDS_SIGNAUX[signal.signal];
        const points = poids * 2 ** (-ageJours / demiVieJours);
        brut += points;
        return { ...signal, poids, ageJours, points };
    })
        .sort((a, b) => b.points - a.points)
        .map((ligne) => ({ ...ligne, points: Math.round(ligne.points) }));
    return { score: Math.round(100 * (1 - Math.exp(-brut / K_SCORE))), brut, lignes };
}
//# sourceMappingURL=score.js.map